export default __webpack_public_path__ + "e9716f6650697e19a9794a2a95956ffd.woff2";